import styled from 'styled-components';

interface PietroskiHeaderProps {
    height?: String;
}

export const PietroskiHeader = styled.div`
    width: 100%;
    height: ${(props: PietroskiHeaderProps) => props.height ? `${props.height}` : `50px`};
    background-color: #545454;
`;